export default __webpack_public_path__ + "static/media/clue@2x.00eac351.webp";